<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Detailed Prior Sales Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                      ✖
                    </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                      ✖
                    </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="GetDetailedPriorSalesReport('N')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="advancedSalesrecords.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- s -->
        <a
          target="_blank"
          @click="GetDetailedPriorSalesReport('Y')"
          title="Download as PDF"
          download
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/pdf.svg"
            height="25"
            width="25"
          />
        </a>
      </div>

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="advancedSalesrecords.length > 0"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th rowspan="2"></th>
                <th colspan="2">Paid Admission (excl Redemption)</th>
                <th colspan="2">Redemptions</th>
                <th colspan="1">Comps</th>
                <th colspan="4">Total Prior Sales</th>
              </tr>
              <tr>
                <th>Seats</th>
                <th>Value</th>

                <th>Seats</th>
                <th>Values</th>

                <th></th>

                <th>Seats</th>
                <th>Value</th>
                <th>Tax</th>
                <th>Net</th>
              </tr>
            </thead>
            <template
              v-for="(DistributorName, DataIndex) in advancedSalesrecords"
            >
              <tr :key="DataIndex" class="distName">
                <th class="text-left" colspan="10">
                  {{ `Distributor - ${DistributorName.d_name}` }}
                </th>
              </tr>
              <template v-for="(saledata, index) in DistributorName.data">
                <tr :key="index">
                  <td class="text-left">
                    {{ saledata.movie_name }}
                  </td>

                  <td class="text-right">
                    {{ saledata.seats_exl_redm }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(saledata.paid_excl_redm) }}
                  </td>
                  <td class="text-right">
                    {{ saledata.redm_seats }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(saledata.redm_paid) }}
                  </td>
                  <td class="text-right">
                    {{ saledata.comp_seats }}
                  </td>
                  <td class="text-right">
                    {{ saledata.seats_exl_redm + saledata.redm_seats }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(saledata.total_value) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(saledata.total_value - saledata.net_value) }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(saledata.net_value) }}
                  </td>
                </tr>
              </template>
              <tr>
                <td colspan="1" class="text-left font-weight-bold">Total</td>
                <td class="text-right">
                  {{
                    DistributorName.data.reduce((acc, { seats_exl_redm }) => {
                      return acc + seats_exl_redm;
                    }, 0)
                  }}
                </td>
                <td class="text-right">
                  {{
                    DistributorName.data.reduce((acc, { paid_excl_redm }) => {
                      return acc + paid_excl_redm;
                    }, 0)
                  }}
                </td>
                <td class="text-right">
                  {{
                    DistributorName.data.reduce((acc, { redm_seats }) => {
                      return acc + redm_seats;
                    }, 0)
                  }}
                </td>
                <td class="text-right">
                  {{
                    DistributorName.data
                      .reduce((acc, { redm_paid }) => {
                        return acc + redm_paid;
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    DistributorName.data.reduce((acc, { comp_seats }) => {
                      return acc + comp_seats;
                    }, 0)
                  }}
                </td>
                <td class="text-right">
                  {{
                    DistributorName.data.reduce(
                      (acc, { seats_exl_redm, redm_seats }) => {
                        return acc + (seats_exl_redm + redm_seats);
                      },
                      0
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    DistributorName.data
                      .reduce((acc, { total_value }) => {
                        return acc + total_value;
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    DistributorName.data
                      .reduce((acc, { total_value, net_value }) => {
                        return acc + (total_value - net_value);
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    DistributorName.data
                      .reduce((acc, { net_value }) => {
                        return acc + net_value;
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
              </tr>
            </template>
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left">Grand Total Prior Sales</th>
                <th class="text-right">
                  {{ grandTotal.seats_exl_redm || 0 }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.paid_excl_redm || 0) }}
                </th>
                <th class="text-right">{{ grandTotal.redm_seats || 0 }}</th>
                <th class="text-right">
                  {{ currFormat(grandTotal.redm_paid || 0 || 0) }}
                </th>
                <th class="text-right">{{ grandTotal.comp_seats || 0 }}</th>
                <th class="text-right">
                  {{ grandTotal.total_seats_value || 0 }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.total_value || 0) }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.tax_value || 0) }}
                </th>
                <th class="text-right">
                  {{ currFormat(grandTotal.net_value || 0) }}
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>

      <table
        v-if="advancedSalesrecords.length === 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
        <thead class="bg-lightgrey">
          <tr>
            <th rowspan="2"></th>
            <th colspan="2">Paid Admission (excl Redemption)</th>
            <th colspan="2">Redemptions</th>
            <th colspan="1">Comps</th>
            <th colspan="4">Total Prior Sales</th>
          </tr>
          <tr>
            <th>Seats</th>
            <th>Value</th>

            <th>Seats</th>
            <th>Values</th>

            <th>Comp</th>

            <th>Seats</th>
            <th>Value</th>
            <th>Tax</th>
            <th>Net</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="14">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      advancedSalesrecords: [],
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {},
  mounted() {},
  methods: {
    onChangeDate(e, type){
      if(type =='from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    GetDetailedPriorSalesReport(isPdf = "N") {
      this.advancedSalesrecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf,
      };
      ReportsService.GetDetailedPriorSalesReport(payload)
        .then((response) => {
          const { data } = response;

          if (data.status && data.Records.length > 0) {
            this.advancedSalesrecords = [...data.Records];
            this.grandTotal = data.grandTotal;
            //console.log(this.grandTotal)
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/detailedPriorSalesReport.vue